import * as Bixby from '$/core';

export abstract class TranscriptionsClientService {
  private static baseUrl = `${Bixby.Constants.API_TRANSCRIPTIONSCONTROLLER}`;

  public static async getTranscriptionsByCompanyId(
    companyId: string
  ): Promise<Bixby.Models.ClientCompanyTranscription[]> {
    const url = `${TranscriptionsClientService.baseUrl}/${Bixby.Constants.API_ACTION_SEARCH}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    const request: Bixby.Models.TranscriptionClientRequest = {
      companyId,
    };
    return await Bixby.API.post(route, request);
  }

  public static async downloadTranscriptionAudio(transcriptionId: string): Promise<Blob> {
    const url = `${TranscriptionsClientService.baseUrl}/${transcriptionId}/${Bixby.Constants.API_ACTION_DOWNLOAD}/${Bixby.Constants.API_ACTION_AUDIO}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.getFile(route);
  }

  public static async downloadTranscriptionText(transcriptionId: string): Promise<Blob> {
    const url = `${TranscriptionsClientService.baseUrl}/${transcriptionId}/${Bixby.Constants.API_ACTION_DOWNLOAD}/${Bixby.Constants.API_ACTION_TEXT}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.getFile(route);
  }

  public static async retrieveTranscriptionText(transcriptionId: string): Promise<string> {
    const url = `${TranscriptionsClientService.baseUrl}/${transcriptionId}/${Bixby.Constants.API_ACTION_RETRIEVE}/${Bixby.Constants.API_ACTION_TEXT}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    const result: string = await Bixby.API.get(route);
    return result;
  }
}
